module.exports = __webpack_public_path__ + "img/2-TWK-Walkthrough-One-Page-MVP.adc804af.png";